import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";

import { Drawer } from "@components";
import styles from "@styles/containers/cdp/audiences.module.scss";
import Charts from "./charts/Charts";
import Records from "./Records";
import OcdpAPI2 from "providers/OcdpAPI2";
const css = classNames.bind(styles);

const TABS = {
  CHARTS: "CHARTS",
  TIMELINE: "TIMELINE",
};

export const AudienceHistory = ({ visible, onClose, audience }) => {
  const [selectedTab, setSelectedTab] = useState(TABS.CHARTS);
  const [reports, setReports] = useState({
    days: [],
    months: [],
    general: []
  });

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (!scrollContainerRef.current) return;

    if (scrollContainerRef.current) scrollContainerRef.current.scrollTo(0, 0);
  }, [selectedTab]);

  useEffect(() => {


    if (audience && visible) {
      const load_audience = async () => {
        const ocdp_api = new OcdpAPI2();
        const response = await ocdp_api.audience(audience.id);
        setReports(response.reports || {});
      }
      load_audience();
    }
  }, [audience, visible])

  return (
    <>
      <Drawer
        visible={visible}
        onClose={onClose}
        withoutTransition
        direction="full-center"
        showCloseButton={false}
      >
        <div className={styles.history}>
          <div className={styles.header}>
            <div className="d-flex flex-column">
              <p className={styles.title}>Ver histórico</p>
              <p className={styles.subtitle}>{audience.name}</p>
            </div>
            <div className="d-flex align-center">
              <div className={styles.close} onClick={onClose}>
                <i className="fas fa-times" />
              </div>
            </div>
          </div>

          <div className={styles.historyContainer}>
            <div className={styles.scrollContainer} ref={scrollContainerRef}>
              {selectedTab === TABS.CHARTS && <Charts days={reports?.days} months={reports?.months} />}
              {selectedTab === TABS.TIMELINE && (
                <Records records={reports?.general} />
              )}
            </div>
          </div>

          <div className={styles.historyFooter}>
            <div className={styles.tabs}>
              <div
                className={css({
                  tab: true,
                  selected: selectedTab === TABS.CHARTS,
                })}
                onClick={() => setSelectedTab(TABS.CHARTS)}
              >
                <span>Ver modo gráfico</span>
              </div>
              <div
                className={css({
                  tab: true,
                  selected: selectedTab === TABS.TIMELINE,
                })}
                onClick={() => setSelectedTab(TABS.TIMELINE)}
              >
                <span>Ver modo listagem</span>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
